function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import { withContext } from "../../wr-context";
import { Row, Col } from "../../grid";
import Button from "../../button";
import styled from "styled-components";
import i18n from "../../../utils/i18n";
var ButtonWithStyles = styled(Button)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.modal.confirmation.buttons.borderRadius;
}, function(param) {
    var theme = param.theme;
    return theme.components.modal.confirmation.buttons.padding;
});
var StyledButton = styled(ButtonWithStyles)(_templateObject1());
var Header = function() {
    return /*#__PURE__*/ React.createElement(Row, {
        center: "xs"
    }, /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement("span", null, i18n("modal.confirmation.confirmation"))));
};
var Footer = withContext(function(param) {
    var context = param.context, onConfirm = param.onConfirm, onDecline = param.onDecline;
    return /*#__PURE__*/ React.createElement(Row, {
        center: "xs"
    }, /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(ButtonWithStyles, {
        onClick: function() {
            context.actions.closeModal();
            onConfirm();
        },
        primary: true
    }, i18n("modal.confirmation.yes"))), /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(StyledButton, {
        onClick: function() {
            context.actions.closeModal();
            onDecline();
        },
        primary: false
    }, i18n("modal.confirmation.no"))));
});
var buildConfirmationModal = function(param) {
    var _header = param.header, header = _header === void 0 ? Header : _header, body = param.body, _footer = param.footer, footer = _footer === void 0 ? Footer : _footer, _onConfirm = param.onConfirm, onConfirm = _onConfirm === void 0 ? function() {} : _onConfirm, _onDecline = param.onDecline, onDecline = _onDecline === void 0 ? function() {} : _onDecline, size = param.size, isOpen = param.isOpen, component = param.component, showClose = param.showClose;
    return {
        header: /*#__PURE__*/ React.createElement(header),
        body: body,
        footer: /*#__PURE__*/ React.createElement(footer, {
            onConfirm: onConfirm,
            onDecline: onDecline
        }),
        size: size,
        isOpen: isOpen,
        component: component,
        showClose: showClose
    };
};
export default buildConfirmationModal;
